












































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import PlayerModal from '../../shared/components/PlayerModal.vue';

@Component({
    components: {
        PlayerModal,
    },
})
export default class Team extends Vue {
    private view: string = 'pitch';
    private playerModal = false;

    private setView(type: string): void {
        this.view = type;
    }

    private openPlayerModal() {
        this.playerModal = true;
    }

    private closePlayerModal() {
        this.playerModal = false;
    }



}
